<template>
    <div class="p-grid">
		<div class="p-col-12">
			<div class="card p-shadow-1">
				<h5>Cálculo do Ponto</h5>
                <hr>

                <ProgressBar :value="progresso" class="p-mb-2" v-if="progresso > 0"/>

                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-6">
                        <label>Empresa</label>
                        <Dropdown v-model.number="idCnpjSelecionado" :options="cnpjs" optionLabel="cnpjNome" optionValue="id" placeholder="Selecione"
                            @change="listarCentrosCustos"/>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label>Centro de custo</label>
                        <Dropdown v-model.number="idCentroCustoSelecionado" :options="centrosCustos" optionLabel="nome" optionValue="id" placeholder="Todos"
                            :filter="true" :showClear="true"/>
                    </div>                               
                </div>
                <Panel header="Selecionar Funcionários">
                    <div class="p-fluid p-formgrid p-grid">
                        <div class="p-field p-col-12 p-md-6">
                            <label>Selecionados</label>
                            <Listbox :options="funcionarios" optionLabel="nome" listStyle="height:300px"/>	
                        </div> 
                        <div class="p-field p-col-12 p-md-6">
                            <label style="color:#ffffff">.</label>                   
                            <div class="p-inputgroup">
                                <InputText v-model.trim="cracha" @keyup.enter="buscarFuncionario()" placeholder="Pesquisar por crachá"/>
                                <Button icon="pi pi-search" title="Buscar" @click="buscarFuncionario()"/>                    
                            </div>	
                        </div>                                                     
                    </div>
                    <div class="p-fluid p-formgrid p-grid">
                        <div class="p-field p-col-0">
                            <Button class="p-button-secondary p-ml-2" icon="pi pi-trash" title="Limpar" @click="limparListaFuncionarios"/> 
                        </div>                                            
                    </div>
                </Panel>   

                <div class="p-fluid p-formgrid p-grid p-mt-3">
                    <div class="p-field p-col-12 p-md-6">
                        <label>Período</label>
                        <Calendar v-model="mesAno" view="month" dateFormat="mm/yy" :showIcon="true" :manualInput="false" 
                        :yearNavigator="true" :yearRange="rangeData" :locale="localeCalendarBR" @date-select="listaDatasPeriodoFechamento"/>				
                    </div> 
                </div>                
                
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-3">
                        <label>Data início</label>
                        <Dropdown v-model="dataInicio" :options="datasPeriodoFechamento" optionLabel="nome" optionValue="valor" appendTo="body"/> 				
                    </div>
                    <div class="p-field p-col-12 p-md-3">
                        <label>Data final</label>
                        <Dropdown v-model="dataFinal" :options="datasPeriodoFechamento" optionLabel="nome" optionValue="valor" appendTo="body"/> 	
                    </div>                    
                </div> 

                <div class="p-field p-col-12 p-md-12 p-mt-2">                   
                    <div class="p-formgroup-inline">
                        <div class="p-field-radiobutton">
                            <RadioButton name="eventoSelecionado" v-model.number="eventoSelecionado" value="simples"/>
                            <label>Período</label>
                        </div>
                        <div class="p-field-radiobutton">
                            <RadioButton name="eventoSelecionado" v-model.number="eventoSelecionado" value="flexivel"/>
                            <label>Data início/Data final</label>
                        </div>
                        <div class="p-field p-col-0">
                        <label style="color:#ffffff">.</label>  
                        <Button label="Calcular" icon="pi pi-calendar-times" @click="prepararCalculo()"/>
                    </div>
                    </div>
                </div>

			</div>
		</div>
    </div>
</template>

<script>
import CentroCustoService from '@/service/CentroCustoService';
import CalculoPontoService from '@/service/CalculoPontoService';
import CentroCusto from '@/model/CentroCusto';
import { exibirMensagem, exibirMensagemSis, clonar, localeCalendarBR} from '@/global';
import { mapGetters, mapActions } from 'vuex';

export default {
    calculoPontoService: null,
    centroCustoService: null,
    data() {
        return {           
            datasPeriodoFechamento: [],            
            idCentroCustoSelecionado: null,
            idCnpjSelecionado: null,
            cnpjs: [],
            centrosCustos: [],
            dataInicio: new Date(),
            dataFinal: new Date(),
            funcionarios: [],
            cracha: '',
            mesAno: new Date(),
            rangeData: '',
            localeCalendarBR: localeCalendarBR,
            progresso: 0,
            eventoSelecionado: 'simples',
            quantidadeFuncionarios: 0,
            linhasPorPagina: 30,
            pararTimeout: false,
        }
    },
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao', 'getCacheEmpresa']),
        ...mapActions('sessao', ['atualizarCacheEmpresa']),     
        executarCalculo() {
            this.progresso = 5;    
            if(this.funcionarios.length > 0 || this.quantidadeFuncionarios <= this.linhasPorPagina) {                       
                if(this.eventoSelecionado == 'simples') {
                    this.calcular();
                } else {
                    this.calcularFlexivel();
                }
            } else {                      
                let totalPaginas = 0;
                let result = this.quantidadeFuncionarios / this.linhasPorPagina;                      
                if((parseInt(result) * this.linhasPorPagina) == this.quantidadeFuncionarios) {
                    totalPaginas = parseInt(this.quantidadeFuncionarios / this.linhasPorPagina);
                } else {
                    totalPaginas = parseInt((this.quantidadeFuncionarios / this.linhasPorPagina)) + 1;
                }
                if(this.eventoSelecionado == 'simples') {
                    this.calcularRecursivo(1, totalPaginas, this.linhasPorPagina);
                } else {
                    this.calcularRecursivoFlexivel(1, totalPaginas, this.linhasPorPagina);
                }
            }
        },
        prepararCalculo() {
            if(this.idCnpjSelecionado == null) {
                exibirMensagemSis(this, 'Selecione uma empresa', true);
                return;
            }
            this.quantidadeFuncionarios = 0;
            this.linhasPorPagina = 30;          
            let idsCentrosCustos = [];
            if(this.idCentroCustoSelecionado == null) {
                this.centrosCustos.forEach(ctc => {
                    idsCentrosCustos.push(ctc.id);
                });
            } else {
                idsCentrosCustos.push(this.idCentroCustoSelecionado);
                this.filtrarCentosCustosFilhos(this.idCentroCustoSelecionado, this.centrosCustos, idsCentrosCustos);
            }            
            let requisicao = {                
                idsCentrosCustos: idsCentrosCustos,              
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };
            this.calculoPontoService.getQuantidadeFuncionarios(requisicao)
            .then(resp => {                                     
                this.quantidadeFuncionarios = resp.data.quantidade;                   
                if(this.quantidadeFuncionarios == 0) {
                    exibirMensagemSis(this, 'Total de funcionários: '+this.quantidadeFuncionarios, true);
                } else {
                    this.executarCalculo();
                }
            })
            .catch(erro => {
                exibirMensagem(this, erro);
                setTimeout(() => {
                    this.progresso = 0;
                }, 3000);
            });            
        },
        calcularRecursivo(pagina, totalPaginas, linhasPorPagina) { 
            if(this.pararTimeout) {
                return;
            }
            let requisicao = this.getRequisicaoCalculo();
            requisicao['pagina'] = pagina;
            requisicao['linhasPorPagina'] = linhasPorPagina;
            this.calculoPontoService.calcularPagina(requisicao)
				.then(resp => {   
                    if((pagina + 1) > totalPaginas) {                       
                        this.progresso = 100;
                        exibirMensagem(this, resp);  
                        setTimeout(() => { this.progresso = 0; }, 1000);
                    } else  {
                        this.progresso = Math.trunc((pagina / totalPaginas)*100);
                        pagina++;
                        this.calcularRecursivo(pagina, totalPaginas, linhasPorPagina);
                    }                 
                })
                .catch(erro => {                   
                    exibirMensagem(this, erro);
                    setTimeout(() => { this.progresso = 0; }, 3000);
                });
        },
        calcularRecursivoFlexivel(pagina, totalPaginas, linhasPorPagina) {
            if(this.idCnpjSelecionado == null) {
                exibirMensagemSis(this, 'Selecione uma empresa', true);
                return;
            }
            let requisicao = this.getRequisicaoCalculo();
            requisicao['pagina'] = pagina;
            requisicao['linhasPorPagina'] = linhasPorPagina;
            this.calculoPontoService.calcularPaginaFlexivel(requisicao)
				.then(resp => {                       
                    if((pagina + 1) > totalPaginas) {                        
                        this.progresso = 100;
                        exibirMensagem(this, resp);  
                        setTimeout(() => { this.progresso = 0; }, 1000);
                    } else  {
                        this.progresso = Math.trunc((pagina / totalPaginas)*100);
                        pagina++;
                        this.calcularRecursivoFlexivel(pagina, totalPaginas, linhasPorPagina);
                    }                       
                })
                .catch(erro => {                  
                    exibirMensagem(this, erro);
                    setTimeout(() => { this.progresso = 0; }, 3000);
                });
        },     
        calcular() {  
            this.progresso = 50;
            let requisicao = this.getRequisicaoCalculo();
            this.calculoPontoService.calcular(requisicao)
				.then(resp => {                          
                    this.progresso = 100;                        
                    setTimeout(() => { this.progresso = 0; exibirMensagem(this, resp); }, 1000);             
                })
                .catch(erro => {                  
                    exibirMensagem(this, erro);
                    setTimeout(() => { this.progresso = 0; }, 3000);
                });
        },
        calcularFlexivel() {            
            this.progresso = 50;
            let requisicao = this.getRequisicaoCalculo();
            this.calculoPontoService.calcularFlexivel(requisicao)
				.then(resp => {            
                    this.progresso = 100;     
                    setTimeout(() => { exibirMensagem(this, resp); this.progresso = 0; }, 1000);                   
                })
                .catch(erro => {
                    exibirMensagem(this, erro);
                    setTimeout(() => { this.progresso = 0; }, 3000);
                });
        },
        buscarFuncionario() {
            if(this.cracha == '') {
                exibirMensagemSis(this, 'No mínimo três caracteres', true);
                return;
            }
            if(this.idCnpjSelecionado == null) {
                exibirMensagemSis(this, 'Selecione uma empresa', true);
                return;
            }
            let requisicao = {
                cracha: this.cracha,
                idCnpj: this.idCnpjSelecionado,
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };
            this.calculoPontoService.buscarFuncionario(requisicao)
				.then(resp => {   
                    let encontrei = false;                    
                    this.funcionarios.forEach(func => {
                        if(func.cracha == resp.data.cracha) {
                            encontrei = true;
                        }
                    });
                    if(!encontrei) {
                        this.funcionarios.push(resp.data);
                    }                                       
                })
                .catch(erro => {exibirMensagem(this, erro)});
        },  
        filtrarCentosCustosFilhos(idCentroCustoPrincipal, centrosCustos, idsCentrosCustos) {
            centrosCustos.forEach(ct => {
                if(ct.id != null 
                    && ct.centroCustoPaiId
                    && ct.centroCustoPaiId == idCentroCustoPrincipal) {
                    idsCentrosCustos.push(ct.id);
                    this.filtrarCentosCustosFilhos(ct.id, centrosCustos, idsCentrosCustos);
                }
            }); 
        },      
        limparListaFuncionarios() {
            this.funcionarios = [];
        },
        listarCnpjs() {
            // Cache dados
            let cacheEmpresa = this.getCacheEmpresa();
            this.cnpjs = cacheEmpresa.cnpjs;
            this.centrosCustos = [];  
            let centroCusto = new CentroCusto();
            centroCusto.nome = 'Todos';
            this.centrosCustos.push(centroCusto);
            Array.prototype.push.apply(this.centrosCustos, [...cacheEmpresa.centrosCustos]);     
            if(cacheEmpresa.idCnpjSelecionado) {
                this.idCnpjSelecionado = cacheEmpresa.idCnpjSelecionado;
            }
        },
        listarCentrosCustos() {
            let cacheEmpresa = this.getCacheEmpresa();
            cacheEmpresa.idCnpjSelecionado = this.idCnpjSelecionado; 
            let requisicao = {
                idCnpj: this.idCnpjSelecionado,
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };
            this.centroCustoService.listarCentrosCustosUsuario(requisicao)
				.then(resp => {                      
                    // Cache dados      
                    cacheEmpresa.centrosCustos = [];              
                    resp.data.forEach(ct => {
                        cacheEmpresa.centrosCustos.push({...ct});
                    }); 
                    this.idContratoSelecionado = null;                     
                    this.centrosCustos = []; 
                    let centroCusto = new CentroCusto();
                    centroCusto.nome = 'Todos';
                    this.centrosCustos.push(centroCusto);
                    Array.prototype.push.apply(this.centrosCustos, resp.data);      
                    this.atualizarCacheEmpresa(cacheEmpresa);                
                })
                .catch(erro => {exibirMensagem(this, erro)});
        },
        listaDatasPeriodoFechamento() {
            let requisicao = {         
                mes: this.mesAno.getMonth()+1,
                ano: this.mesAno.getFullYear(),      
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };
            this.calculoPontoService.listaDatasPeriodoFechamento(requisicao)
				.then(resp => {                       
                    this.datasPeriodoFechamento = [];
                    resp.data.forEach(data => {
                        this.datasPeriodoFechamento.push({ nome: data, valor: data });
                    });
                    this.dataInicio = this.datasPeriodoFechamento[0].valor;  
                    this.dataFinal = this.datasPeriodoFechamento[0].valor;                    
                })
                .catch(erro => {exibirMensagem(this, erro)});
        },
        getRequisicaoCalculo() {  
            let idsCentrosCustos = [];
            if(this.idCentroCustoSelecionado == null) {
                this.centrosCustos.forEach(ctc => {
                    if(ctc.id != null) {
                        idsCentrosCustos.push(ctc.id);
                    }
                });
            } else {
                idsCentrosCustos.push(this.idCentroCustoSelecionado);
            }
            let cnpj = null;
            for(let i = 0; i < this.cnpjs.length; i++) {
                if(this.idCnpjSelecionado == this.cnpjs[i].id) {
                    cnpj = this.cnpjs[i];
                    break;
                }
            }
            const funcionariosEnivar = clonar(this.funcionarios);
            funcionariosEnivar.forEach(funcio => {
                funcio.dataAdmissao = null;
                funcio.dataCadastro = null;
                funcio.centroCusto = null;
            });
            let requisicao = {
                idsCentrosCustos: idsCentrosCustos,
                funcionarios: funcionariosEnivar,
                cnpj: {...cnpj},
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };
            requisicao['dataInicio'] = this.dataInicio;
            requisicao['dataFinal'] = this.dataFinal;        
            requisicao['mes'] = this.mesAno.getMonth()+1;
            requisicao['ano'] = this.mesAno.getFullYear();                  
            return requisicao;
        },         
        criarRangeData() {
            let anoAtual = new Date().getFullYear();     
            this.rangeData = (anoAtual-10)+':'+(anoAtual+20);     
        },        
    },
    created() {      
        this.calculoPontoService = new CalculoPontoService();
        this.centroCustoService = new CentroCustoService();       
    },
    mounted() {
        this.pararTimeout = false;
        this.listarCnpjs();     
        this.criarRangeData(); 
    },
    beforeDestroy() {
        this.pararTimeout = true;
    }
}
</script>

<style>

</style>